/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_L1_CarddetailsInputs */

const en_visa_l1_carddetails = /** @type {(inputs: Visa_L1_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporary classifications for qualifying executives, managers, or specialized-knowledge employees transferring within related companies.`)
};

const pt_visa_l1_carddetails = /** @type {(inputs: Visa_L1_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificações temporárias para executivos, gerentes ou empregados com conhecimento especializado transferidos entre empresas relacionadas e qualificadas.`)
};

const es_visa_l1_carddetails = /** @type {(inputs: Visa_L1_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificaciones temporales para ejecutivos, gerentes o empleados con conocimiento especializado transferidos entre empresas relacionadas y calificadas.`)
};

/**
* | output |
* | --- |
* | "Temporary classifications for qualifying executives, managers, or specialized-knowledge employees transferring within related companies." |
*
* @param {Visa_L1_CarddetailsInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_l1_carddetails = /** @type {((inputs?: Visa_L1_CarddetailsInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_L1_CarddetailsInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_l1_carddetails(inputs)
	if (locale === "es") return es_visa_l1_carddetails(inputs)
	return en_visa_l1_carddetails(inputs)
});